// Saves the "Edit Property Details" modal in the background instead of doing a
// full-page form submit + redirect (which redrew the whole page and bypassed
// the app's real-time architecture).
//
// On success the property broadcasts an update over DataUpdatesChannel, which
// refreshes the list row and merges into any open slideover. We also trigger a
// full slideover refetch so fields not in the lightweight broadcast payload
// (areas, council tax band, parking, etc.) appear immediately.
export const propertyEditModal = () => ({
  saving: false,
  errors: [],

  async save(event) {
    if (this.saving) return;

    const form = event.target;
    this.saving = true;
    this.errors = [];

    try {
      const response = await fetch(form.action, {
        // The form carries _method=patch; POST lets Rails apply the override.
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        },
        body: new FormData(form),
      });

      if (response.ok) {
        const id = form.dataset.propertyId;
        Alpine.store("modals").isPropertyEditModalOpen = false;

        // Pull full, current data into the open slideover (broadcast payload is
        // lightweight and omits some edited fields).
        const entry = Alpine.store("slideovers")?.openSlideovers?.[`property-${id}`];
        entry?.component?.fetchProperty?.(true);
      } else if (response.status === 422) {
        const data = await response.json().catch(() => ({}));
        this.errors = Array.isArray(data) ? data : Object.values(data).flat();
        if (this.errors.length === 0) this.errors = ["Could not save the property."];
      } else {
        this.errors = ["Could not save the property. Please try again."];
      }
    } catch (e) {
      this.errors = ["Could not save the property. Please try again."];
    } finally {
      this.saving = false;
    }
  },
});
